export const MOQ_VARIANT_ENTITY = 'VARIANT';

export const MOQ_PRODUCT_ENTITY = 'PRODUCT';

export const MOQ_CATALOGUE_ENTITY = 'CATALOGUE';

export const MOQ_COMPANY_ENTITY = 'COMPANY';
